// extracted by mini-css-extract-plugin
module.exports = {"root":"file_root__1cndl"};